import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useCallback } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import TextLink from 'components/TextLink';
import Icon from 'components/Icon';
import DropIndicator from 'components/DropIndicator';
import { setAlert } from 'actions/alerts';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var BrowseLink = function BrowseLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(TextLink, {
      bold: true,
      as: "span",
      children: children
    })]
  });
};
var FileUploader = function FileUploader(_ref2) {
  var onSelect = _ref2.onSelect;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var selectFile = useCallback(function (acceptedFiles) {
    var _acceptedFiles = _slicedToArray(acceptedFiles, 1),
      selectedFile = _acceptedFiles[0];
    onSelect({
      file: selectedFile
    });
  }, [onSelect]);
  var rejectFile = useCallback(function (rejectedFiles) {
    if (rejectedFiles.length > 1) {
      setAlert({
        title: t('error_upload_only_single_file')
      });
    } else {
      setAlert({
        title: "".concat(t('error_uploading_file'), ": ").concat(rejectedFiles[0].name)
      });
    }
  }, [t]);
  var _useDropzone = useDropzone({
      multiple: false,
      onDropAccepted: selectFile,
      onDropRejected: rejectFile
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject;
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsxs(DropIndicator, {
      p: "m",
      textAlign: "center",
      isDragActive: isDragActive,
      isDragReject: isDragReject,
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "upload",
        scale: 4
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsxs(Trans, {
          t: t,
          i18nKey: "modal_upload_file_drop_file_message",
          children: ["Drop a file here or", /*#__PURE__*/_jsx(BrowseLink, {
            children: "browse"
          }), " to upload"]
        })
      })]
    })]
  }));
};
export default FileUploader;